module.exports = __webpack_public_path__ + "img/jiujingongcan_image_zc.e1cb4434.png";